// Widths in px. Below MOBILE_MENU_MAX_WIDTH the header renders MobileMenu.
export const PHONE_MAX_WIDTH = 480;
export const TABLET_MIN_WIDTH = 800;
export const MEDIUM_SCREEN_MAX_WIDTH = 1024;
export const MOBILE_MENU_MAX_WIDTH = 1024;
export const LARGE_TABLET_MAX_WIDTH = 1180;
// Desktop menu still shows here but space is tight; nav sizes step down.
export const NARROW_DESKTOP_MAX_WIDTH = 1350;
export const WIDE_DESKTOP_MIN_WIDTH = 1600;
